import templateUrl from "webutils/text-switcher.htm";
import basicController from "servicestack/basic.controller.properties";

export class TextSwitcherControler {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
  }
  $onChanges() {
    this.text =
      this.condition || this.ngModel
        ? this.trueText || this.on || "Yes"
        : this.falseText == "notext"
          ? "" : this.falseText || this.off || "No";
    this.className = this.condition
      ? this.trueClass || "text-success"
      : this.falseClass || "text-danger";
  }
}

export default {
  bindings: {
    condition: "<",
    ngModel: "<",
    trueText: "@",
    on: "@",
    trueClass: "@",
    falseText: "@",
    off: "@",
    falseClass: "@"
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
  controller: TextSwitcherControler
};
